<template>
    <div class="d-loader" :style="{width: size+'px', height: size+'px'}" style="margin: 1rem; position: relative; display: inline-flex; vertical-align: middle;" :class="[loaderClasses]">
      <svg v-if="type === 'spinner'" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" :class="color">
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(1 1)" stroke-width="2">
            <circle stroke-opacity=".25" cx="18" cy="18" r="18" stroke="currentColor" />
            <path d="M36 18c0-9.94-8.06-18-18-18" stroke="currentColor">
              <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.8s" repeatCount="indefinite" />
            </path>
          </g>
        </g>
      </svg>
      <svg v-else-if="type === 'dots'" viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg" :class="color">
        <circle cx="15" cy="15" r="15" fill="currentColor">
          <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite" />
          <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />
        </circle>
        <circle cx="60" cy="15" r="9" fill="currentColor" fill-opacity="0.3">
          <animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite" />
          <animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite" />
        </circle>
        <circle cx="105" cy="15" r="15" fill="currentColor">
          <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite" />
          <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />
        </circle>
      </svg>
    </div>
  </template>
  
  <script>
    /**
     * @displayName DLoader
     */
    export default {
      name: 'DLoader',
      props: {
        /**
         * Must be a Tailwind color class. IE - `text-primary-500` or `text-blue-600`
         */
        color: {
          type: String,
          default: 'text-primary',
        },
  
        /**
         * Type of loading animation
         * `spinner, dots`
         */
        type: {
          type: String,
          default: 'spinner',
        },
  
        /**
         * Set the square size of the loader
         */
  
        size: {
          type: Number,
          default: 64,
        },
      },
  
      computed: {
        loaderClasses() {
          return [];
        },
      },
    };
  </script>
  